// @flow

const tagsHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  })
};

export default tagsHomeStyles;
